
import { data, get } from 'jquery';
import icon from '../../images/SkillduleIcon.jpg';
import AddSchedule from '../partials/AddSchedule';
import { getAuth } from 'firebase/auth';
import { useState, useEffect } from 'react';
import { getUser } from '../../js/database';
import Schedule from './Schedule';
import { useSelector, useDispatch } from 'react-redux';
import { setUser } from '../../slices/userSlice.js';
import { setDatabase } from '../../slices/databaseSlice.js';
import { getLocalSchedule, setLocalSchedule } from '../../js/localDB';
import { useNavigate } from 'react-router-dom';
import { login as loginAndRedirect } from "../../js/script";
import logo from "../../images/SkillduleLogo.png";

function Landing() {
    //const [user, setUser] = useState(0);
    const [user, database] = useSelector(state => [state.user, state.database]);
    const [login, setLogin] = useState(true); // [login, setLogin
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const auth = getAuth();
     //   console.log(auth.currentUser);
        const searchQuery = new URLSearchParams(window.location.search);
        if (searchQuery.has("shareId")) {
          getUser(searchQuery.get("shareId")).then((data) => {
            var user = data.info;
            user.shared = true;
          dispatch(setUser(user));
          dispatch(setDatabase(data));

          })
        } else if (searchQuery.has("schedule")) {
          window.localStorage.setItem("schedule", atob(searchQuery.get("schedule")));
          window.location.href = window.location.origin;
        } else {
        auth.onAuthStateChanged((user) => {
            if (user) {
          //      console.log(user);
                getUser(user.uid).then((data) => {
          //        console.log(data);
                    dispatch(setDatabase(data));
                    dispatch(setUser(user.toJSON()))
                }).catch((e) => {
                  console.log(e);
                })

            } else {
                if (getLocalSchedule()) {
                  console.log("Local Schedule Found");
                  var data = getLocalSchedule();
                  if (!data.hasOwnProperty("settings")) data.settings = {tname:true, rnumber:true, period:false, pe:false, wschedule:false, coverride:false, homework:""}; 
                  data.settings.local = true;
                  dispatch(setDatabase(data));
                  dispatch(setUser({uid: 0, local:true}));
                    
                } else {
                  setLogin(false);
                }
            }
        })
      }
    //  setLogin(false);
      window.onresize = () => {
        setWindowWidth(window.innerWidth);
      }
    }, []);
    if (login && Object.keys(user).length === 0) return;
    if (database && database.hasOwnProperty("classes") && Object.entries(database.classes).length > 0) return <Schedule/>
    else {
  return (
    <div className="bg-dark text-white container-fluid App">
<div class="bg row justify-content-center text-center">
  <div class="caption text-center">
    <h3 class="startMobile mt-4">WITANDSKILLDULE</h3>
    {windowWidth < 1335 ?
    <img class="img-fluid" src={icon}/> :
    <img class="img-fluid" src={logo}/>}
    <h5>Schedule, Lunch, Homework, MXes, and more all in one place.<br/>
      "Don't have a schedule, have a Skilldule."</h5>
      {windowWidth > 1335 ?
      <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#setSchedule">Get Started</button> :
      <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#setSchedule" disabled>Setup on Desktop</button>}
      <p>If you have already setup Skilldule, <a href="#" onClick={() => {
      //  console.log("clicked")
       loginAndRedirect().then(() => {
          navigate(0);
        })
      }}>click here</a> to login.</p>
      <br/><a href="/setup"  class="mt-2" target="_blank">View Setup Guide</a>
      <p class="lead startMobile">NOTE: Setup must be preformed in a browser with a console interface.</p>
      
  </div>
  <div class="row footer pt-4 text-center">
    <p class="lead">WIT&SKILLDULE is a division of the <a href="https://media.discordapp.net/attachments/784994278966951936/981220444680118312/binbows.png" target="_blank">JSFFund of America</a></p>
</div>
      


</div>





<AddSchedule user={user} windowWidth={windowWidth}/>
<div class="modal fade" id="faq" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog">
<div class="modal-content bg-dark">
<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel">Help!</h5>
</div>
<div class="modal-body">
  <h5>FAQ:</h5>
  <div class="accordion accordion-flush text-black" id="accordionExample">
<div class="accordion-item">
  <h2 class="accordion-header" id="headingOne">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
      One of my classes isn't showing up.
    </button>
  </h2>
  <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
    <div class="accordion-body">
      Please contact us at the email below and include the full name of the class as listed on the Parker Portal.
    </div>
  </div>
</div>
<div class="accordion-item">
  <h2 class="accordion-header" id="headingTwo">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
      My schedule reset!
    </button>
  </h2>
  <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
    <div class="accordion-body">
      This is most likely because you deleted the cookies associated with WIT&amp;SKILLDULE. To prevent further resetting, refrain from deleting Skilldule's cookies (because they are very tasty).
    </div>
  </div>
</div>
<div class="accordion-item">
  <h2 class="accordion-header" id="headingThree">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseTwo">
      Who started the fire?
    </button>
  </h2>
  <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
    <div class="accordion-body">
      Ryan started the fire.
    </div>
  </div>
</div>
</div>
<div class="border-top my-3"></div>
<h5>Contact Us:</h5>
<p>Email: <a href="mailto:jadee@fwparker.org">Jack Adee</a></p>
  <div class="text-center"><button class="btn btn-primary" data-bs-dismiss="modal">OK</button></div>
</div>
</div>
</div>
</div>

  {/* <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.9.3/dist/umd/popper.min.js" integrity="sha384-eMNCOe7tC1doHpGoWe/6oMVemdAVTMs2xqW4mwXrXsW0L84Iytr2wi5v2QjrP/xp" crossorigin="anonymous"></script>
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/js/bootstrap.min.js" integrity="sha384-cn7l7gDp0eyniUwwAZgrzD06kc/tftFf19TOAs2zVinnD/C7E91j9yyk5//jjpt/" crossorigin="anonymous"></script> */}


</div>


  );
}
}

export default Landing;